export default class InvoiceNumberConfig {
    static fromData(data) {
        if (!data) {
            return;
        }

        const invoiceNumberConfig = new InvoiceNumberConfig();
        invoiceNumberConfig.prefix = data.invoiceNumberPrefix;
        invoiceNumberConfig.initialNumber = data.invoiceNumberRangeStart;
        invoiceNumberConfig.padNumberWithLeadingZeros = data.invoiceNumberLeadingZeros;
        invoiceNumberConfig.numberDigits = data.invoiceNumberDigits;
        invoiceNumberConfig.useMonth = data.invoiceNumberUseMonth;
        invoiceNumberConfig.useYear = data.invoiceNumberUseYear;
        invoiceNumberConfig.resetNumberYearly = data.invoiceNumberResetYearly;

        return invoiceNumberConfig;
    }
}
